import { getText } from 'src/ConsentManagement/TranslationService';

type TotalOptedInModel = {
  optedIn: number;
  totalOptions: number;
  isEssential?: boolean;
};

export const TotalOptedIn = ({ optedIn, totalOptions, isEssential = false }: TotalOptedInModel) => {
  return (
    <span class="cc-accordion-header-checklist">
      {isEssential ? getText('essential') : `${optedIn}/${totalOptions} ${getText('accepted')}`}
    </span>
  );
};
